export const FillManuallyOptionTexts = {
  Label: 'Заполнить самостоятельно',
};
